import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import logo from '../../images/logo-horizontal.svg';
import cartIcon from '../../images/icons/cart.svg';
import donationIcon from '../../images/icons/donation.svg';
import chatIcon from '../../images/icons/chat.svg';
import './Header.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Header extends Component {
	openCalendly = () => {
		window.Calendly.showPopupWidget('https://calendly.com/showtix4u');
		// Accessibility - Add focus on iframe when opening Calendly
		let calendlyIframe = document.querySelectorAll('.calendly-popup iframe')[0];
		setTimeout(() => {
			calendlyIframe.setAttribute('title', 'Showtix Support');
			calendlyIframe.setAttribute('tabIndex', -1);
			calendlyIframe.focus();
		}, 1000);
	};
	
	headerButtons = (param) => {
		if(param.indexOf('/events') !== -1){
			return (
				<div className="showtix-header__options">
					<div className="showtix-header__call-center">
						<div className="showtix-header__call-center__text d-flex flex-column align-items-start justify-content-start">
							<button
								onClick={() => this.openCalendly()}
								aria-label="Access here the Showtix Support"
							>{strings.contactUs}</button>
						</div>  
					</div>
					<button
						className="showtix-header__cart"
						onClick={this.props.toggleCart}
						aria-expanded={this.props.isCartOpen}
						aria-controls="cart-main"
						aria-label="Toggle Cart"
					>
						<div className="showtix-header__cart__total">
                            {this.props.totalItemsInCart}
						</div> 
						<div className="showtix-header__cart__image"> 
							<img src={cartIcon} alt="cart icon"/>
						</div>  
					</button>
				</div>
			)
		}

		/* if(param.indexOf('/flex') !== -1){
			return (
				<div className="showtix-header__options">
					<button className="showtix-header__save showtix-button showtix-background__primary-1">
						<span>{strings.saveDraft}</span>  
					</button>
					<button className="showtix-header__save showtix-button showtix-background__grey-3">
						<span>{strings.savePublish}</span>  
					</button>
				</div>
			)
		} */

		if(param.indexOf('/event') !== -1 && param.indexOf('/events') === -1 && param.indexOf('/search') === -1 && param.indexOf('/event-details') === -1){
			return (
				<div>
					{ !this.props.isEventDraftButtonHidden ? 
						<div className="showtix-header__options showtix-header__options-buttons">
							<button
								className="showtix-header__save showtix-button showtix-background__primary-1"
								onClick={this.props.toggleSaveDraftEvent}
							>
								<span>{strings.saveDraft}</span>  
							</button>
							<button
								className="showtix-header__save showtix-button showtix-background__grey-3"
								onClick={this.props.toggleSavePublishEvent}
								disabled={this.props.isReservedSeatingNew}
							>
								<span>{strings.savePublish}</span>  
							</button>
						</div>	
					: 
						<div className="showtix-header__options showtix-header__options-buttons">
							<button
								className="showtix-header__save showtix-button showtix-background__grey-3"
								onClick={this.props.savePublishEvent}
							>
								<span>{strings.savePublish}</span>  
							</button>
						</div>
					}
				</div>
			)
		}

		if(param.indexOf('/client/') !== -1 || param.indexOf('/onboarding') !== -1){
			if (param.indexOf('/pos') === -1) {
				return (
					<div className="showtix-header__options">
						<button
							className="showtix-header__save showtix-button showtix-background__primary-1"
							onClick={this.props.updateClientPreferences}
						>
							<span>{strings.update}</span>  
						</button>
					</div>
				)
			} else {
				return null;
			}
		}

		// Coupon
        if(param.indexOf('/create-coupon') !== -1){
            let buttonLabel = (this.props.couponExists) ? strings.saveCoupon : strings.createCoupon;
            return (
				<div>
                { this.props.showSaveCouponBtn &&
				<div className="showtix-header__options showtix-header__options-buttons">
					<button
						className="showtix-header__save showtix-button showtix-background__primary-1"
						onClick={() => this.props.saveUpdateCouponEvent(true)}
						disabled={!this.props.isReadyToSubmitCoupon}
					>
						<span>{buttonLabel}</span>
					</button>
				</div>
                }
				</div>
			)
		}

		// Flexpass
        if(param.indexOf('/create-flexpass') !== -1){
            let buttonLabel = (this.props.flexpassExists) ? strings.saveFlexpass : strings.createFlexpass;
            return (
				<div className="showtix-header__options showtix-header__options-buttons">
					<button
						className="showtix-header__save showtix-button showtix-background__primary-1"
						onClick={() => this.props.saveUpdateFlexpassEvent(true)}
						disabled={!this.props.isReadyToSubmitFlexpass}
					>
						<span>{buttonLabel}</span>
					</button>
				</div>
            )
        }

		// Stream
		return this.streamButtons(param);
	}

	headerButtonsPatron = (param) => {
		// Events
		if(param.indexOf('/events') !== -1){
			return (
				<div className="showtix-header__options">
					<div className="showtix-header__call-center"> 
						<div className="showtix-header__call-center__text d-flex flex-column align-items-start justify-content-start">
							<button onClick={() => this.openCalendly()}>{strings.contactUs}</button>
						</div>  
					</div>
					<button className="showtix-header__cart" onClick={this.props.toggleCart}>
						<div className="showtix-header__cart__total">
                            {this.props.totalItemsInCart}
						</div> 
						<div className="showtix-header__cart__image"> 
							<img src={cartIcon} alt="cart icon"/>
						</div>  
					</button>
				</div>
			)
		}

		// Stream
		return this.streamButtons(param);
	};

	streamButtons(param) {
		const hasChat = this.props.streamEvent.event_type === "Live Stream" || this.props.streamEvent.event_type === "Scheduled Content";
		if((param.indexOf('/stream') !== -1 || param.indexOf('/demo') !== -1) && this.props.streamEvent.client_id){
			return (
				<div className="showtix-header__options">
					<Link
						className="showtix-header__donation"
						target="_blank"
						to={{
							pathname: `/events/${this.props.streamEvent.client_id}`,
							search: "?action=donation",
						}}
					>
						<div className="showtix-header__donation__image">
							<img src={donationIcon} alt="donation icon"/>
						</div>
					</Link>
					{ hasChat &&
					<button className="showtix-header__chat" onClick={this.props.toggleChat}>
						<div className="showtix-header__chat__image">
							<img src={chatIcon} alt="chat icon"/>
						</div>
					</button>
					}
				</div>
			)
		}
	}
	
	render() {
		const isInStreamPage = this.props.location.pathname.indexOf('/stream') !== -1 || this.props.location.pathname.indexOf('/demo') !== -1;
		return (
			<nav className={isInStreamPage ? 'showtix-header showtix-header--stream-page' : 'showtix-header'}>
				<div className="container">
					<button
						className={!this.props.isNavigationOpen ? 'showtix-header__toggle-navigation' : 'showtix-header__toggle-navigation is-active'}
						onClick={this.props.toggleNav}
						aria-label="Toggle navigation"
						id="navigation-toggle"
					>
						<i></i>
						<i></i>
						<i></i>
					</button>

					<a className="showtix-header__brand" href="/">
						<img src={logo} alt="ShowTix4U"/>
					</a>

                    {this.props.isLoggedinUser ? (
						this.headerButtons(this.props.location.pathname)
					) : (
						this.headerButtonsPatron(this.props.location.pathname)
					)}
				</div>
			</nav>
		);
	}
}

export default withRouter(Header);

Header.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string
    }).isRequired,
    cartItems: PropTypes.array,
	isNavigationOpen: PropTypes.bool,
    isEventDraftButtonHidden: PropTypes.bool,
    totalTickets: PropTypes.number,
    toggleCart: PropTypes.func,
    toggleSaveDraftEvent: PropTypes.func,
    toggleSavePublishEvent: PropTypes.func,
    savePublishEvent: PropTypes.func,
	streamEvent: PropTypes.object,
	toggleChat: PropTypes.func,
};


// WEBPACK FOOTER //
// ./src/components/Header/Header.js